// extracted by mini-css-extract-plugin
export default {"internetHealthBar":"app_internetHealthBar__F5u3i"};